import { useInjectReducer } from "@app/store";
import PageContent from "@components/PageContent";
import PageHeader from "@components/PageHeader";
import Table from "@components/Table";
import { useLoadAllSmsMutation } from "@features/admin/sms/smsApiSlice";
import { makeSelectQuery } from "@features/admin/sms/smsSelector";
import smsSlice, { setQueryValue } from "@features/admin/sms/smsSlice";
import { APP_NAME } from "@utils/constants";
import { queryHelper } from "@utils/queryHelper";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";

const SmsList = () => {
  useInjectReducer("smsManage", smsSlice);
  const dispatch = useDispatch();
  const query = useSelector(makeSelectQuery);
  const [sms, { data: smsData, isSuccess: success, isLoading: loadingLogin }] =
    useLoadAllSmsMutation();
  const data = smsData?.data;

  useEffect(() => {
    sms();
  }, []);

  const handlePagination = ({ page, size }) => {
    dispatch(setQueryValue({ key: "page", value: page }));
    dispatch(setQueryValue({ key: "size", value: size }));
    sms(queryHelper({ ...query, page, size }));
  };

  const tableData = data?.map(
    ({ _id, added_at, device_id, message, phone_number }) => [
      <span className="capitalize">{device_id}</span>,
      message ? message : "",
      phone_number ? phone_number : "",
      added_at,
    ]
  );
  return (
    <>
      <Helmet>
        <title>{`SMS | ${APP_NAME}`}</title>
      </Helmet>
      <PageHeader title="SMS" />
      <PageContent>
        <Table
          tableHead={tableHead}
          tableData={tableData}
          emptyDataMsg="No Data Found"
          pagination={{
            page: smsData?.page,
            size: smsData?.size,
            totalData: smsData?.totalData,
          }}
          handlePagination={handlePagination}
          loading={loadingLogin}
          isSN
          ispublic
        />
      </PageContent>
    </>
  );
};

export default SmsList;

const tableHead = ["Device", "Message", "Mobile Number", "Added At"];
